import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column fill-height justify-center align-center text-white ma-3" }
const _hoisted_2 = { class: "d-flex flex-column fill-height justify-center align-center text-white ma-3 pa-2" }
const _hoisted_3 = { class: "d-flex flex-column fill-height justify-center align-center ma-3 pa-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_parallax = _resolveComponent("v-parallax")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_parallax, {
      src: require('../assets/img/h1bg.png'),
      gradient: "to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-h2 font-weight-thin mb-4 pa-2" }, "ใส่ใจวัยเก๋า", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "subheading" }, [
            _createTextVNode(" วิเคราะห์ความเสี่ยงการล้ม ป้องกันการล้มผู้สูงอายุ ด้วย AI อัจฉริยะ "),
            _createElementVNode("br"),
            _createTextVNode(" เทคโนโลยีเฝ้าระวังอุบัติเหตุ ที่ช่วยลดความเสี่ยงและเพิ่มความปลอดภัย ")
          ], -1)),
          _createVNode(_component_v_btn, {
            color: "primary",
            class: "ma-3 pa-2",
            to: "/thaifrat"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("เริ่มต้นใช้งาน")
            ])),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["src"]),
    _createVNode(_component_v_parallax, {
      src: require('../assets/img/h2bg.png'),
      gradient: "to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_card, {
            class: "align-center justify-center d-flex",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "font-weight-thin align-center justify-center d-flex text-h4" }, " ทำไมการป้องกันการล้มถึงสำคัญ? ", -1)),
                  _createVNode(_component_v_row, {
                    dense: "",
                    class: "ma-5 pa-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "4",
                        xs: "4",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1",
                            outlined: "",
                            "max-width": "344",
                            height: "100"
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createElementVNode("p", null, "เมื่อ 1 คนล้ม ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        xs: "4",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1",
                            outlined: "",
                            "max-width": "344",
                            height: "100"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createElementVNode("p", null, "หกล้มเพียง 1 ครั้ง ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        xs: "4",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1",
                            outlined: "",
                            "max-width": "344",
                            height: "100"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createElementVNode("p", null, "เสียหายมากกว่าที่คิด", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["src"]),
    _createVNode(_component_v_parallax, {
      src: require('../assets/img/h5bg.png')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_card, {
            variant: "text",
            color: "dark"
          }, {
            default: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "text-h4 align-center justify-center d-flex" }, " ระบบของเรา ทำงานอย่างไร? ", -1)),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "6",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("mdi-chart-line")
                            ])),
                            _: 1
                          }),
                          _cache[8] || (_cache[8] = _createTextVNode(" วิเคราะห์ความเสี่ยงเฉพาะบุคคล "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "6",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("mdi-eye")
                            ])),
                            _: 1
                          }),
                          _cache[10] || (_cache[10] = _createTextVNode(" ตรวจจับด้วย AI & Computer Vision "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "6",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-bell")
                            ])),
                            _: 1
                          }),
                          _cache[12] || (_cache[12] = _createTextVNode(" แจ้งเตือนทันทีผ่านแอปพลิเคชัน "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "6",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "text-sm-h6 align-center justify-center d-flex pa-2 ma-2 text-body-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("mdi-chart-bar")
                            ])),
                            _: 1
                          }),
                          _cache[14] || (_cache[14] = _createTextVNode(" รายงานข้อมูลและแนวโน้มความเสี่ยง "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "text-h4 font-weight-thin align-center justify-center d-flex pa-4" }, " เสียงจากผู้ใช้งานจริง ", -1)),
          _createVNode(_component_v_card, {
            "append-icon": "mdi-comment-account",
            class: "align-center justify-center d-flex pa-2 ma-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "text-sm-h6 font-weight-thin align-center justify-center text-body-1" }, [
                    _createTextVNode(" “ตั้งแต่ใช้ระบบนี้ เราสามารถเฝ้าระวังผู้สูงอายุ"),
                    _createElementVNode("br"),
                    _createTextVNode("ได้ดียิ่งขึ้น ลดอุบัติเหตุได้จริง” ")
                  ], -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("h5", null, [
                    _createTextVNode("-"),
                    _createElementVNode("strong", null, "เจ้าหน้าที่ศูนย์ดูแล"),
                    _createTextVNode("-")
                  ], -1)),
                  _createVNode(_component_v_btn, {
                    color: "success",
                    class: "mt-3",
                    to: "/about"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("ทดลองใช้งานฟรี 30 วัน")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["src"])
  ], 64))
}